// be able to get the text

const filterFaq = (questionsNodeList, queryText) => {
  const searchResults = [];
  questionsNodeList.forEach((node) => {
    const questions = node.querySelectorAll(".faq-question__question");
    const answers = node.querySelectorAll(".m-collapsible--content__inner");

    for (let x = 0; x < questions.length; x++) {
      let question = questions[x].textContent;
      let answer = answers[x].textContent;

      if (
        question.toLowerCase().includes(queryText.toLowerCase().trim()) ||
        answer.toLowerCase().includes(queryText.toLowerCase().trim())
      ) {
        let result = createSearchResult(question, answer);
        searchResults.push(result);
      }
    }
  });
  return searchResults;
};
const createSearchResult = (query, content) => {
  const outerDiv = document.createElement("div");
  const outerContentDiv = document.createElement("div");
  const contentDiv = document.createElement("div");
  const trigger = document.createElement("h5");
  trigger.className = "row h5";

  const span1 = document.createElement("span");
  span1.textContent = query;
  const span2 = document.createElement("span");
  span2.className = "m-collapsible--icon";
  span2.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5306 6.53073L8.5306 11.5307C8.46092 11.6007 8.37813 11.6561 8.28696 11.694C8.1958 11.7318 8.09806 11.7513 7.99935 11.7513C7.90064 11.7513 7.8029 11.7318 7.71173 11.694C7.62057 11.6561 7.53778 11.6007 7.4681 11.5307L2.4681 6.53073C2.3272 6.38984 2.24805 6.19874 2.24805 5.99948C2.24805 5.80023 2.3272 5.60913 2.4681 5.46823C2.60899 5.32734 2.80009 5.24818 2.99935 5.24818C3.19861 5.24818 3.3897 5.32734 3.5306 5.46823L7.99997 9.93761L12.4693 5.46761C12.6102 5.32671 12.8013 5.24756 13.0006 5.24756C13.1999 5.24756 13.391 5.32671 13.5318 5.46761C13.6727 5.60851 13.7519 5.7996 13.7519 5.99886C13.7519 6.19812 13.6727 6.38921 13.5318 6.53011L13.5306 6.53073Z" fill="currentColor"/>
        </svg>
    `;
  trigger.appendChild(span1);
  trigger.appendChild(span2);
  outerDiv.classList.add("search-results__wrapper", "faq-section__wrapper");
  contentDiv.classList.add("content", "hidden");
  contentDiv.style.width = "90%";
  contentDiv.style.marginInline = "auto";
  contentDiv.textContent = content;
  outerContentDiv.append(contentDiv);
  outerDiv.appendChild(trigger);
  outerDiv.appendChild(outerContentDiv);

  return outerDiv;
};

const handleTriggerClick = (e) => {
  const currentTrigger = e.target;
  const parent = e.target.closest(".search-results__wrapper");
  const currentContent = parent.querySelector(".content");
  document.querySelectorAll(".content").forEach((content) => {
    if (content !== currentContent) {
      content.classList.add("hidden");
    }
  });
  currentContent.classList.toggle("hidden");
};

if (document.readyState === "complete") {
  const faq = document.querySelectorAll(".m-faqs-section__block-accordion");
} else {
  window.addEventListener("load", () => {
    const faq = document.querySelectorAll(".faq-section__wrapper");
    const input = document.getElementById("custom-faq-hero[search]");
    const searchBtn = document.getElementById("clear-search");
    const resultsContainer = document.getElementById("search-results");
    if (input){
      input.addEventListener("input", (e) => {
        if (searchBtn.classList.contains("cancel-search-display")) {
          searchBtn.classList.remove("cancel-search-display");
        }
      });
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          searchBtn.click();
        }
      });
    }
    if (searchBtn){
      searchBtn.addEventListener("click", (e) => {
        let results = filterFaq(faq, input.value);
        searchBtn.classList.add("cancel-search-display");
        input.value = "";
        resultsContainer.replaceChildren();
        results.forEach((res) => {
          resultsContainer.appendChild(res);
          const trigger = res.querySelector("h5.row.h5");
          trigger.addEventListener("click", handleTriggerClick);
        });
      });

    }
  });
}
